export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00226.0ecf5938.png";